<div [class.switchers]="imagesArray && imagesArray?.length > 0" [ngClass]="{'switchers_mobile': data?.isMobile}">
  <div class="header">
    <div class="download">
      <a class="as-link download-icon"  (click)="downloadFile(currentImage)">
        <i class="fa-light fa-arrow-down-to-bracket"></i>
      </a>
      <p class="file-name pointer" (click)="downloadFile(currentImage)">{{currentImage.name}}</p>
    </div>

    <div class="counter" *ngIf="imagesArray && imagesArray?.length > 1 && imageIndex !== undefined && imageIndex !== null">
      {{ (imageIndex + 1) + '/' + imagesArray?.length }}
    </div>

    <div class="back-action" (click)="close()">
      <i class="fa-light fa-close pointer"></i>
    </div>
  </div>
  <div class="view" >
    <ng-container *ngIf="currentImage.src" [ngSwitch]="currentImage.type">
      <ng-container *ngSwitchCase="'video'">
        <vg-player class="flex-1">
          <video
            #media [vgMedia]="$any(media)"
            (canplay)="onCanPlay($event)"
            [vgHls]="currentImage.src"
            preload="metadata"
            id="singleVideo"
            controls
          ></video>
        </vg-player>
        <!-- <lib-home365-video-player class="video-player" [src]="data.src"></lib-home365-video-player> -->
      </ng-container>
      <ng-container *ngSwitchCase="'pdf'">
        <div class="pdf-view">
          <lib-home365-loader *ngIf="loadingDoc" size="l"></lib-home365-loader>
          <pdf-viewer [src]="currentImage.src"
                      [original-size]="false"
                      (on-progress)="onProgressPdf($event)"
          ></pdf-viewer>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'image'">
        <div class="img-view">
          <img
            style="width: 100%; height: 100%"
            [src]="currentImage.src"
            draggable="false" />
        </div>
      </ng-container>
      <ng-container *ngSwitchDefault>
      </ng-container>
    </ng-container>
  </div>
  <ng-container *ngIf="imagesArray && imagesArray?.length > 1 && imageIndex !== undefined && imageIndex !== null">
    <div class="prev" (click)="switchImage('prev')" [class.disabled]="imageIndex === 0"><i class="fa-light fa-angle-left"></i></div>
    <div class="next" (click)="switchImage('next')" [class.disabled]="imageIndex === imagesArray?.length - 1"><i class="fa-light fa-angle-right"></i></div>
  </ng-container>
</div>


